import { Component, ErrorInfo, ReactNode } from 'react'
import { isChunkLoadError, reloadOnceForChunkError } from '../lib/lazy-with-retry'

declare global {
  interface Window {
    __reportClientError?: (message: string, stack?: string, source?: string) => void
  }
}

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (isChunkLoadError(error)) {
      reloadOnceForChunkError()
      return
    }

    const stack = error.stack || info.componentStack || ''
    if (typeof window.__reportClientError === 'function') {
      window.__reportClientError(error.message || 'Render error', stack, 'react-boundary')
    } else {
      console.error('ErrorBoundary caught:', error, info)
    }
  }

  private handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '24px',
            textAlign: 'center',
            gap: '12px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          }}
        >
          <div style={{ fontSize: '15px', color: '#666' }}>Что-то пошло не так</div>
          <div style={{ fontSize: '13px', color: '#999', maxWidth: '300px' }}>
            Произошла ошибка при загрузке приложения
          </div>
          <button
            onClick={this.handleReload}
            style={{
              marginTop: '8px',
              padding: '10px 24px',
              borderRadius: '10px',
              border: '1px solid #ddd',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: '15px',
            }}
          >
            Перезагрузить
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
